import { Adapter as e } from "../../../../../adapter.js";
import { AdyenApplePaymentMethod as r } from "./adyenApplePayPaymentMethod.model.js";
class m extends e {
  adapt(n) {
    return new r({
      brands: n.brands,
      name: n.name,
      type: n.type,
      configuration: {
        merchantId: n.configuration.merchant_id,
        merchantName: n.configuration.merchant_name
      }
    });
  }
  serialize(n) {
    return {
      brands: n.brands,
      name: n.name,
      type: n.type,
      configuration: {
        merchant_id: n.configuration.merchantId,
        merchant_name: n.configuration.merchantName
      }
    };
  }
}
export {
  m as AdyenApplePayPaymentMethodAdapter
};
//# sourceMappingURL=adyenApplePayPaymentMethod.adapter.js.map
